var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.pageLayoutData)?[(_vm.hpSlider)?_c('slider',_vm._b({class:[("el-size--" + (_vm.elementSizes[0]))],attrs:{"observe-resize":0}},'slider',_vm.hpSlider,false)):_vm._e(),_c('div',{staticClass:"mis-promo container text-center rel"},[_c('div',[_c('h2',{ref:"title",staticClass:"text-center hp-title",class:[
            _vm.animateLogo || _vm.dirtyHome ? 'logo-in' : '',
            _vm.logoMove || _vm.dirtyHome ? 'logo-move' : '',
            _vm.logoReady || _vm.dirtyHome ? 'logo-ready' : '',
            _vm.animateLetters || _vm.dirtyHome ? 'next' : ''
          ]},[_c('logo',{staticClass:"with-slogan",attrs:{"animate":""},on:{"animation-end":_vm.logoTransitionEnd}}),_c('span',{class:[
              'slogan-box',
              'font-rg',
              'pl-s',
              'ml-s',
              _vm.animateLetters || _vm.dirtyHome ? 'animate' : ''
            ],attrs:{"id":"logo-slogan"},on:{"transitionend":_vm.sloganTransitionEnd}},[_vm._v("MAKE IT SIMPLE")])],1),_c('h3',{class:[
            'logo-extra',
            _vm.sloganReady || _vm.dirtyHome ? 'show' : '',
            'text-center',
            'text-gray-6'
          ],domProps:{"textContent":_vm._s(_vm.localize('hp_our_mission'))}})])]),(_vm.hpBoxes)?_c('hp-boxes',_vm._b({class:[("el-size--" + (_vm.elementSizes[1]))],attrs:{"observe-resize":1}},'hp-boxes',_vm.hpBoxes,false)):_vm._e()]:_c('preloader')],2)}
var staticRenderFns = []

export { render, staticRenderFns }